export default __webpack_public_path__ + "static/logo-ABOMS-7e6b40f7d54d1f609da03ea295d1e7d9.svg";